import React, { ChangeEventHandler, MouseEventHandler } from "react";
import Switch from "@ingka/switch";

import "@ingka/focus/dist/style.css";
import "@ingka/switch/dist/style.css";

interface Props {
  id: string;
  checked?: boolean;
  value: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
  disabled?: boolean;
  readOnly?: boolean;
  subtle?: boolean;
  "data-testid"?: string;
  label?: React.ReactNode;
}

export const FixaSwitch = (props: Props) => {
  return <Switch {...props} />;
};
